import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.state';
import { conversationReducer } from './conversations/conversations.reducer';

export const reducers: ActionReducerMap<AppState> = {
  history: conversationReducer
};
